/**
 * Copyright (c) Microsoft. All rights reserved.
 */

import React from 'react';
import { getRandomNumber } from 'src/core/utils/randomValueGenerators';

export const useIdGeneratorForNewQnaPair = () => {
    const [newPairId, setNewPairId] = React.useState<number>(-1);

    const generateIdForNewPair = () => {
        const id = getRandomNumber();

        setNewPairId(id);

        return id;
    };

    const getNewPairId = () => newPairId;

    return {
        getNewPairId,
        generateIdForNewPair
    };
};
